module.exports = __webpack_public_path__ + "media/images/sponsorLogo-7736cdc5a0eae2a725d5ded3826d3bd4.png";